import { Add, Refresh, SaveAlt } from "@mui/icons-material";
import { Box, Button, Divider, IconButton, Tooltip } from "@mui/material";
import { makeSxStyles } from "ui";

interface HeaderStandardActionsProps {
  onFlexGrow?: number;
  onRefresh?: () => void;
  onExportCSV?: () => void;
  onAdd?: () => void;
  addButtonText?: string;
  addButtonDisabled?: boolean;
  addButtonTooltip?: string;
  customActions?: React.ReactNode;
  customActionsPlacement?: "before" | "after";
}

const HeaderStandardActions = ({
  onFlexGrow,
  onRefresh,
  onExportCSV,
  onAdd,
  addButtonText,
  addButtonDisabled,
  addButtonTooltip,
  customActions,
  customActionsPlacement = "after",
}: HeaderStandardActionsProps) => {
  const styles = useStyles();

  return (
    <Box sx={styles.section} justifyContent="flex-end" flexGrow={onFlexGrow}>
      {onRefresh && (
        <IconButton onClick={onRefresh} color="primary">
          <Refresh />
        </IconButton>
      )}
      {onExportCSV && (
        <IconButton onClick={onExportCSV} color="primary">
          <SaveAlt />
        </IconButton>
      )}
      <Divider sx={styles.divider} orientation="vertical" variant="middle" />
      {customActionsPlacement === "before" && customActions}
      {onAdd &&
        (addButtonTooltip ? (
          <Tooltip title={addButtonTooltip}>
            <span>
              <Button
                variant="contained"
                onClick={onAdd}
                startIcon={<Add />}
                disabled={addButtonDisabled}
                data-testid="add-button"
              >
                {addButtonText || "Add new entity"}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            variant="contained"
            onClick={onAdd}
            startIcon={<Add />}
            disabled={addButtonDisabled}
            data-testid="add-button"
          >
            {addButtonText || "Add new entity"}
          </Button>
        ))}
      {customActionsPlacement === "after" && customActions}
      <Divider sx={styles.divider} orientation="vertical" variant="middle" />
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  section: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    gap: "8px",
    marginRight: "8px",
  },
  divider: {
    height: "18px",
  },
}));

export default HeaderStandardActions;
